import { render, staticRenderFns } from "./BanIn.vue?vue&type=template&id=d5e9b1ba&scoped=true"
import script from "./BanIn.vue?vue&type=script&lang=js"
export * from "./BanIn.vue?vue&type=script&lang=js"
import style0 from "./BanIn.vue?vue&type=style&index=0&id=d5e9b1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e9b1ba",
  null
  
)

export default component.exports